<section class="main-content wrapper content-padding" style="margin-top: 50px;">
  <div class="content-panel">
    <!--
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link active-tab"
        >
          TRANSAZIONI
        </a>
      </label>
    </div>
    -->
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/transzioni"
          routerLinkActive="active-tab"
        >
          TRANSAZIONI
        </a>
      </label>
  
      <!-- 
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/finanza/margini"
          routerLinkActive="active-tab"
        >
          MARGINI
        </a>
      </label> 
      -->
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
